// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"68557c94bdb73113f2e5","678":"6f71f26f46d3b4f9594f","731":"f3eced92dbd5d9a44c7c","843":"6a0c22aebb6f16c23031","883":"7d616489094cd33d27a1"}[chunkId] + ".js";
};